import TextAnswer from './TextAnswer';
export default TextAnswer;
